/**
 * B2B Login Form Mock Component
 *
 * Mirrors the injected form markup that Azure B2C delivers to the B2B login page.
 * Used for local iteration and styling without redeploying to accept.
 *
 * Structure captured from actual B2C form injection with the following notes:
 * - Omits data-lastpass-icon-root noise
 * - Maintains all form IDs and class names for SCSS targeting
 * - Placeholder href for #forgotPassword (Azure B2C fills this with real token on render)
 */

const LoginFormMock = () => {
  return (
    <>
      <div className="heading">
        <h1 role="heading">Sign in with your email</h1>
      </div>
      <form aria-label="Sign in with your email address" className="localAccount" id="localAccountForm">
        <div className="intro">
          <h2>Sign in with your email address</h2>
        </div>
        <div aria-hidden="true" className="error pageLevel" role="alert">
          <p></p>
        </div>
        <div className="entry">
          <div className="entry-item">
            <label htmlFor="signInName">Email Address</label>
            <div aria-hidden="true" className="error itemLevel" role="alert" style={{ display: 'none' }}>
              <p>Please enter your email address</p>
            </div>
            <input
              aria-label="Email Address"
              aria-required="true"
              autoFocus
              className=""
              id="signInName"
              name="Email Address"
              placeholder="Email Address"
              title="Please enter a valid email address"
              type="text"
            />
          </div>
          <div className="entry-item">
            <div className="password-label">
              <label htmlFor="password">Password</label>
              <a href="#" id="forgotPassword">
                Forgot your password?
              </a>
            </div>
            <div aria-hidden="true" className="error itemLevel" style={{ display: 'none' }}>
              <p role="alert">Please enter your password</p>
            </div>
            <input
              aria-label="Password"
              aria-required="true"
              autoComplete="current-password"
              className=""
              id="password"
              name="Password"
              placeholder="Password"
              type="password"
            />
          </div>

          <div className="working"></div>

          <div className="buttons">
            <button form="localAccountForm" id="next" type="submit">
              Sign in
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default LoginFormMock;
